// extracted by css-extract-rspack-plugin
var _1 = "useBulkNote-m_body-d2qzFACg";
var _2 = "useBulkNote-m_form-zzrc1mEE";
var _3 = "useBulkNote-m_preview-PINeSwjS";
var _4 = "useBulkNote-m_radios-Q80kjTfu";
export { _1 as "body", _2 as "form", _3 as "preview", _4 as "radios" }
